import React, { useState, useEffect, useRef } from 'react';
import { messagesForEvacuation } from '../helpers/messages';
import { getDatabase, ref, onValue } from "firebase/database";
import { generatePodcastScript, geocodeAddress, getPathTimes, getTravelExperienceEnglishSummary } from '../helpers/AI_functions';
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, getDocs, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { haversineDistance, dijkstra, reconstructPath, formatTime } from '../helpers/generalHelpers';
import { getTravelExperienceToDestinations, buildTravelNarrative, getTravelExperiencesV2, selectTwoDiverseRoutes, buildTravelNarrativeV2, buildTravelNarrativeV3, getRouteTables } from '../helpers/route_functions';
import HospitalIcon from "../assets/images/hospital.png";
import SafetyIcon from '../assets/images/safety_icon.png';
import LocationIcon from '../assets/images/user-location.png';
import FireImage from '../assets/images/fire_img.png'
import ParkingIconGreen from '../assets/images/parking_icon_green.svg';
import BalloonsOverlay from './FunScreens/BalloonsOverlay';
import { listAll } from "firebase/storage";
import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import {
    getFAQItems,
    getResourceSegments,
    routesAudioTimings,
    routesAudioTimings_ES,
    routesAudioTimings_old_ES,
    routesAudioTimings_old2,
    routeChecklistItems
  } from '../helpers/podcastHelpers';
  
import { darkMapStyle, HOSPITAL_LOCATION, LANGUAGES } from '../helpers/mapHelpers';
import SearchBar from '../components/SearchBar';
import "./InteractiveMapUI.css"

// Replace with your actual API key.
const GOOGLE_MAPS_API_KEY = 'AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU';

const firestore = getFirestore();

const containerStyle = {
  width: '100%',
  height: '740px'
};

const center = {lat: 37.721941, lng: -122.127001};
const DEFAULT_LOCATION = { lat: 37.721941, lng: -122.127001 };



// Destination nodes for shortest route search


const ROUTE_SCENES = [];
const ROUTE_SCENES_OLD = [];


const RES_URL_KNOW = "https://protect.genasys.com/search";  // Zonehaven Aware
const RES_URL_ALERTS = "https://member.everbridge.net/453003085612570/new";        // Alameda County Alerts (San Leandro)

const InteractiveMapOld = () => {
  // Existing states
  const [selectedWorries, setSelectedWorries] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('EN');
  const [selectedTab, setSelectedTab] = useState('routes');
  const [podcastStream, setPodcastStream] = useState("");
  const [podcastUploadPoint, setPodcastUploadPoint] = useState(null);
  const [podcastAudioUrl, setPodcastAudioUrl] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [travelExperiences, setTravelExperiences] = useState(true);
  const [isPodcastPlaying, setIsPodcastPlaying] = useState(false);
  const [travelExpNarrativeStream, setTravelExpNarrativeStream] = useState("");
  const mapRef = useRef(null);
  const podcastAudioRef = useRef(null);
  const safetyCalloutsRef = useRef([]);
  const [routesAudioUrl, setRoutesAudioUrl] = useState("");
  const routesAudioRef = useRef(null);
  const routesDataRef = useRef([]);   // ←  NEW
  const activeRouteNodeRef = useRef(null);   // remembers last highlight
  const [destinationNodes, setDestinationNodes] = useState([]);
  const firePolygonsRef = useRef([]);               // to hold the map Polygon instances
  const [firePolygons, setFirePolygons] = useState([]); // optional if you ever want to inspect them
  const [isMobile, setIsMobile] = useState(false)
  const prefillDoneRef = useRef(false);
  const [mapReady, setMapReady] = useState(false);
  const wantRoutesAutoplayRef = useRef(false);
  const nearestNodeIdRef = useRef(null);


  // Map section states
  const [time, setTime] = useState(180);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [simulations, setSimulations] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState();
  const [showPolyLines, setShowPolyLines] = useState(false);
  const [showAssumptions, setShowAssumptions] = useState(false);
  // Graph data state
  const [graphData, setGraphData] = useState({ links: [], nodes: {}, adjList: {} });
  // New state for car markers (if using Markers)
  const carMarkersRef = useRef([]);
  // We'll continue to use the existing polylineRefs.
  const polylineRefs = useRef([]);
  const circleRef = useRef(null);
  // New state to hold car overlays (if switching to OverlayView, see previous example)
  const [carOverlays, setCarOverlays] = useState([]);
  const [CalloutOverlayClass, setCalloutOverlayClass] = useState(null);

  const [searchText,      setSearchText]      = useState("");   // text in the bar
  const [isSearchingLoc,  setIsSearchingLoc]  = useState(false); // spinner flag

  // Storyboard overlay refs
const linkGeomsRef = useRef({});                // link_id -> WKT geometry
const storyboardLinkPolysRef = useRef(new Map()); // linkId -> google.maps.Polyline
const storyboardNodeMarkersRef = useRef(new Map()); // nodeId -> google.maps.Marker
const storyboardFirePolysRef = useRef([]); // Fire polygon ref
const lastStoryboardCameraRef = useRef(null);   // {lat,lng,zoom}
const [activeCallout, setActiveCallout] = useState(null); // { text, bg, textColor } | null
const [balloonsSpec, setBalloonsSpec] = useState(null);
const [nodeIdText, setNodeIdText] = useState("");

const isEnglish = selectedLanguage === 'EN';
const activeChecklistItems = routeChecklistItems;
const activeRoutesAudioTimings = isEnglish ? routesAudioTimings : routesAudioTimings_ES;
const resourcesI18n = isEnglish
  ? { title: "Next steps", know: "Know your zone", alerts: "AC Alerts" }
  : { title: "Siguientes pasos", know: "Conoce tu zona", alerts: "Alertas de Alameda County" };

const [resourcesAudioUrl, setResourcesAudioUrl] = useState("");
const resourcesAudioRef = useRef(null);
const [activeResourceKey, setActiveResourceKey] = useState(null);   // 'zones' | 'alerts' | null
const [resourceProgress, setResourceProgress] = useState({});       // { key: seconds }

const hospitalMarkerRef = useRef(null);
const [isSavingRoutes, setIsSavingRoutes] = useState(false);
const [saveMsg, setSaveMsg] = useState("");


const handleSaveRouteTables = async () => {
  setSaveMsg("");
  if (!nearestNodeIdRef.current) {
    setSaveMsg("Pick a location on the map first so we know the nearest node.");
    return;
  }
  if (!Array.isArray(travelExperiences) || travelExperiences.length === 0) {
    setSaveMsg("No travel experiences yet. Click “Get travel narrative” first.");
    return;
  }

  try {
    setIsSavingRoutes(true);
    const tables = getRouteTables(travelExperiences); // [{ id, exitName, path, leaveOnTime, fft, leave10MinLate }, ...]
    const db = getFirestore();
    const podcastId = "test_1"
    const ref = doc(db, "podcasts", podcastId, "podcast_details", String(nearestNodeIdRef.current));

    // Upsert the route tables without disturbing subcollections
    await setDoc(
      ref,
      { routeTables: tables, updatedAt: serverTimestamp() },
      { merge: true }
    );

    setSaveMsg("Saved route tables ✅");
  } catch (e) {
    console.error(e);
    setSaveMsg("Failed to save route tables.");
  } finally {
    setIsSavingRoutes(false);
  }
};

// One animation loop per polyline
const linkAnimRef = useRef(new Map()); // polyline -> { raf, spawnTimer, cars:[], color:"#186EE3", fft:5 }
const STOP_ANIMS = () => {
  linkAnimRef.current.forEach(({ raf, spawnTimer, poly }) => {
    if (raf) cancelAnimationFrame(raf);
    if (spawnTimer) clearInterval(spawnTimer);
    // also clear icons so no dots are left
    if (poly) poly.set('icons', []);
  });
  linkAnimRef.current.clear();
};

// show/hide the animated dots on a given polyline
const SET_LINK_ANIM_VISIBLE = (poly, visible) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  st.visible = !!visible;
  if (!visible) {
    // immediately clear any existing dots
    try { st.poly.set('icons', []); } catch (_) {}
  }
};

// start or restart animation for a single polyline
const START_LINK_ANIM = (poly, color, fftSec) => {
  const prev = linkAnimRef.current.get(poly);
  if (prev) {
    if (prev.raf) cancelAnimationFrame(prev.raf);
    if (prev.spawnTimer) clearInterval(prev.spawnTimer);
  }

  const state = {
    poly,
    color,                 // moving-dot color, and also used for stroke
    baseColor: color,      // remember original so we can restore after a scene
    baseQueueColor: color,
    fft: Math.max(0.5, Number(fftSec) || 5),
    cars: [],              // { born:number(ms) }
    raf: 0,
    spawnTimer: 0,
    running: true,
    visible: true,
    queue: {
      count: 0,
      spacingPct: 4,
      color: '#186EE3',    // default queue-dot color
      multiplier: 1        // scene override scales this
    }
  };

  // spawn a new car every 2s (change to 1000 if you want the old rate)
  state.spawnTimer = setInterval(() => {
    state.cars.push({ born: performance.now() });
    if (state.cars.length > 120) state.cars.splice(0, state.cars.length - 120);
  }, 2000);

  const tick = () => {
    if (!state.running) return;
    const now = performance.now();
    const icons = [];
    const durMs = state.fft * 1000;

    const gm = window?.google?.maps;
    if (!gm) {
      state.raf = requestAnimationFrame(tick);
      return;
    }

    if (!state.visible) {
      state.poly.set('icons', []);
      state.raf = requestAnimationFrame(tick);
      return;
    }

    // Effective queued count after scene multiplier
    const q = state.queue;
    const effectiveCount = Math.max(0, Math.floor((q.count || 0) * (q.multiplier || 1)));
    const queuedSpanPct = effectiveCount * Math.max(1, q.spacingPct);
    const freeEndPct = Math.max(0, 100 - queuedSpanPct);

    // moving dots only in the free portion
    for (let i = state.cars.length - 1; i >= 0; i--) {
      const age = now - state.cars[i].born;
      if (age >= durMs) { state.cars.splice(i, 1); continue; }
      const travelPct = Math.min(100, (age / durMs) * 100);
      if (travelPct <= freeEndPct) {
        icons.push({
          icon: {
            path: gm.SymbolPath.CIRCLE,
            scale: 5,
            strokeOpacity: 0,
            fillOpacity: 1,
            fillColor: state.color
          },
          offset: `${travelPct}%`
        });
      }
    }

    // queued dots from the end backward (clipped to link)
    if (effectiveCount > 0) {
      const qIcon = {
        path: gm.SymbolPath.CIRCLE,
        scale: 5,
        strokeOpacity: 0,
        fillOpacity: 1,
        fillColor: q.color || '#FF3B30'
      };
      for (let i = 0; i < effectiveCount; i++) {
        const offsetFromEnd = i * Math.max(1, q.spacingPct);
        const offset = 100 - offsetFromEnd;
        if (offset < freeEndPct) break;
        icons.push({ icon: qIcon, offset: `${Math.max(freeEndPct, Math.min(100, offset))}%` });
      }
    }

    state.poly.setOptions({ strokeOpacity: 0.35, strokeColor: state.color });
    state.poly.set('icons', icons);
    state.raf = requestAnimationFrame(tick);
  };

  state.raf = requestAnimationFrame(tick);
  linkAnimRef.current.set(poly, state);
};

// update color (e.g., when you flip a link to orange)
const UPDATE_LINK_ANIM_COLOR = (poly, newColor) => {
  const st = linkAnimRef.current.get(poly);
  if (st) st.color = newColor;
};

const SET_LINK_QUEUE = (poly, count, spacingPct = 4, color) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  st.queue.count = Math.max(0, Math.floor(Number(count) || 0));
  st.queue.spacingPct = Math.max(1, Number(spacingPct) || 4);
  if (color) {
    st.queue.color = color;
    st.baseQueueColor = st.baseQueueColor || color;  // <— capture once
  }
  
};

const APPLY_TRAFFIC_OVERRIDE = (spec) => {
  const color = spec?.color;
  const mult = spec?.congestionMultiplier;
  linkAnimRef.current.forEach((st) => {
    if (color) {
      st.color = color;        // moving dots and stroke
      st.queue.color = color;  // queued dots match scene color
    }
    if (typeof mult === 'number' && !Number.isNaN(mult)) {
      st.queue.multiplier = Math.max(0, mult);
    }
  });
};

const CLEAR_TRAFFIC_OVERRIDE = () => {
  linkAnimRef.current.forEach((st) => {
    st.color = st.baseColor || st.color;
    st.queue.multiplier = 1;
    st.queue.color = st.baseQueueColor || '#186EE3';
    // keep whatever queue color was set by API or default red
  });
};

const activeScenesRef = useRef(ROUTE_SCENES);
useEffect(() => {
  activeScenesRef.current = isEnglish ? ROUTE_SCENES : ROUTE_SCENES_OLD;
}, [isEnglish]);

// Load "Podcast media/ResourcesV1.mp4" once
useEffect(() => {
  const storage = getStorage();
  getDownloadURL(storageRef(storage, "Podcast media/ResourcesV1.mp4"))
    .then(setResourcesAudioUrl)
    .catch(err => console.error("Error fetching resources audio:", err));
}, []);

useEffect(() => {
  if (prefillDoneRef.current) return;

  const qs = typeof window !== "undefined" ? window.location.search : "";
  if (!qs) return;

  const params = new URLSearchParams(qs.replace(/\?\s*/, "?").replace(/&&/g, "&"));
  const langParam = params.get("lang");
  const streetParam = params.get("street");

  if (langParam) {
    const L = String(langParam).trim().toUpperCase();
    if (L === "EN" || L === "ES") setSelectedLanguage(L);
  }

  const graphReady = graphData && Object.keys(graphData.nodes || {}).length > 0;
  const destReady = Array.isArray(destinationNodes) && destinationNodes.length > 0;
  const ready = !!selectedSimulation && destReady && graphReady && mapReady;

  if (streetParam && ready) {
    const streetText = decodeURIComponent(streetParam).replace(/\+/g, " ").trim();
    setSearchText(streetText);

    /*(async () => {
      try {
        setIsSearchingLoc(true);
        const { lat, lng } = await geocodeAddress(streetText, "", "");
        const latNum = +lat, lngNum = +lng;

        setSelectedLocation({ lat: latNum, lng: lngNum });

        if (mapRef.current) {
          modifyMapCamera(mapRef.current, { lat: latNum, lng: lngNum }, 14.5, 1000);
        }

        await drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);

        // Only mark done after a successful draw
        prefillDoneRef.current = true;
      } catch (e) {
        console.error("Prefill geocode/draw failed:", e);
        // do not mark done so it can retry when prerequisites change
      } finally {
        setIsSearchingLoc(false);
      }
    })();*/
  }
}, [selectedSimulation, destinationNodes, time, graphData, mapReady]);

const resourceSegments = React.useMemo(
  () => getResourceSegments(isEnglish ? 'EN' : 'ES'),
  [isEnglish]
);

const faqList = React.useMemo(
  () => getFAQItems(isEnglish ? 'EN' : 'ES'),
  [isEnglish]
);

const stopResourcePlayback = () => {
  const a = resourcesAudioRef.current;
  if (a) a.pause();
  setActiveResourceKey(null);
};

const playResourceSegment = (seg) => {
  const a = resourcesAudioRef.current;
  if (!a || !resourcesAudioUrl) return;

  // Toggle stop if clicking the active item
  if (activeResourceKey === seg.key) {
    stopResourcePlayback();
    return;
  }

  // Start this snippet
  setActiveResourceKey(seg.key);
  a.currentTime = seg.start;
  a.play().catch(() => {}); // ignore brief play() race
  setResourceProgress(p => ({ ...p, [seg.key]: 0 }));
};

// Keep per-item relative progress & auto-stop at segment end
useEffect(() => {
  const a = resourcesAudioRef.current;
  if (!a) return;

  const onTime = () => {
    const seg = resourceSegments.find(s => s.key === activeResourceKey);
    if (!seg) return;

    if (a.currentTime >= seg.end) {
      stopResourcePlayback();
      a.currentTime = seg.end;
      return;
    }

    const rel = Math.max(0, a.currentTime - seg.start);
    const dur = Math.max(0, seg.end - seg.start);
    setResourceProgress(prev => ({ ...prev, [seg.key]: Math.min(rel, dur) }));
  };

  const onEnded = () => stopResourcePlayback();

  a.addEventListener("timeupdate", onTime);
  a.addEventListener("ended", onEnded);
  return () => {
    a.removeEventListener("timeupdate", onTime);
    a.removeEventListener("ended", onEnded);
  };
}, [activeResourceKey, resourceSegments, resourcesAudioUrl]);



const setSafetyCalloutsVisible = (show) => {
  if (!safetyCalloutsRef.current) return;
  safetyCalloutsRef.current.forEach(ov => {
    if (!ov) return;
    ov.setMap(show ? mapRef.current : null);
  });
};

// Create (or update) a polyline for a link id with a given color
const ensureLinkPolyline = (linkId, color = "#186EE3") => {
  const id = String(linkId);
  const map = mapRef.current;
  if (!map) return null;

  let poly = storyboardLinkPolysRef.current.get(id);
  if (!poly) {
    const wkt = linkGeomsRef.current[id];
    if (!wkt) return null;
    const coords = wkt
      .replace(/^LINESTRING\s*\(/i, "")
      .replace(/\)$/, "")
      .split(",")
      .map(pt => {
        const [lng, lat] = pt.trim().split(" ").map(Number);
        return { lat, lng };
      });

    poly = new window.google.maps.Polyline({
      path: coords,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 1,
      strokeWeight: 5,
      zIndex: 1000,
      clickable: false
    });
    storyboardLinkPolysRef.current.set(id, poly);
  }

  poly.setOptions({ strokeColor: color, strokeOpacity: 1 });
  if (!poly.getMap()) poly.setMap(map);
  return poly;
};

// Create (or update) a marker for a node id
const ensureNodeMarker = (nodeId, { iconUrl, color } = {}) => {
  const id = String(nodeId);
  const map = mapRef.current;
  if (!map || !graphData?.nodes?.[id]) return null;

  let marker = storyboardNodeMarkersRef.current.get(id);
  const { lat, lng } = graphData.nodes[id];

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    // simple colored dot if no icon
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

const ensureCustomMarker = ({ key, lat, lng, iconUrl, color }) => {
  const map = mapRef.current;
  if (!map || typeof lat !== "number" || typeof lng !== "number") return null;

  const id = String(key || `latlng:${lat},${lng}`);
  let marker = storyboardNodeMarkersRef.current.get(id);

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(60, 60),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

// Hide everything created by the storyboard
const hideAllStoryboardOverlays = () => {
  storyboardLinkPolysRef.current.forEach(poly => poly.setMap(null));
  storyboardNodeMarkersRef.current.forEach(m => m.setMap(null));
  storyboardFirePolysRef.current.forEach(p => p.setMap(null)); 
  storyboardFirePolysRef.current = [];                         
};

// Apply a storyboard "scene" object { camera, links[], nodes[], ... }
const applyStoryboardScene = (scene) => {
  if (!scene) return;

  // Camera (smooth if changed)
  if (scene.camera && mapRef.current) {
    const { center, zoom } = scene.camera;
    const last = lastStoryboardCameraRef.current;
    const changed =
      !last ||
      Math.abs((last.center?.lat ?? 0) - center.lat) > 1e-6 ||
      Math.abs((last.center?.lng ?? 0) - center.lng) > 1e-6 ||
      (last.zoom !== zoom);

    if (changed) {
      modifyMapCamera(mapRef.current, center, zoom, 1000);
      lastStoryboardCameraRef.current = { center, zoom };
    }
  }

  // LINKS: force red + high z-index unless overridden in scene
  const visibleLinks = new Set();
  (scene.links || []).forEach(l => {
    const poly = ensureLinkPolyline(l.id, l.color || "#FF0000");
    if (poly) {
      poly.setOptions({
        strokeColor: l.color || "#FF0000",
        zIndex: typeof l.zIndex === "number" ? l.zIndex : 9999,
        strokeOpacity: 1
      });
      visibleLinks.add(String(l.id));
    }
  });
  storyboardLinkPolysRef.current.forEach((poly, id) => {
    if (!visibleLinks.has(id)) poly.setMap(null);
  });

  // Markers (nodes + custom icons share one registry)
  const visibleMarkerKeys = new Set();

  // Legacy node markers still supported
  (scene.nodes || []).forEach(n => {
    const marker = ensureNodeMarker(n.nodeId, { iconUrl: n.iconUrl, color: n.color });
    if (marker) visibleMarkerKeys.add(String(n.nodeId));
  });

  // NEW: icons by lat/lng; currently supports { type: "flag", lat, lng, key? }
  (scene.icons || []).forEach(icon => {
      if (typeof icon.lat !== "number" || typeof icon.lng !== "number") return;
      const type = String(icon.type || "flag").toLowerCase();
      const iconUrl =
        type === "parking" ? ParkingIconGreen : /* school uses flag too */ SafetyIcon;
      const key = String(icon.key || `${type}:${icon.lat},${icon.lng}`);
      const marker = ensureCustomMarker({
        key,
        lat: icon.lat,
          lng: icon.lng,
          iconUrl
        });
        if (marker) visibleMarkerKeys.add(key);
      });

  // Hide any storyboard markers not declared in this scene
  storyboardNodeMarkersRef.current.forEach((m, id) => {
    if (!visibleMarkerKeys.has(id)) m.setMap(null);
  });

  storyboardFirePolysRef.current.forEach(p => p.setMap(null));
  storyboardFirePolysRef.current = [];

  if (scene.firePolygons && scene.firePolygons.length && mapRef.current) {
    // Reuse an existing fire color (latest/highest zIndex one if present)
    const baseColor = (firePolygons && firePolygons[0] && firePolygons[0].color) || "rgb(255,69,0)";

    scene.firePolygons.forEach(fp => {
      const polygon = new window.google.maps.Polygon({
        paths: fp.path,
        fillColor: baseColor,
        fillOpacity: 0.8,
        strokeColor: baseColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map: mapRef.current,
        zIndex: 9998
      });
      storyboardFirePolysRef.current.push(polygon);
    });
  }
};

// Given a current time (seconds), find the scene and apply it
const applyStoryboardForTime = (tSec) => {
  const scenes = activeScenesRef.current || [];
  if (!scenes.length) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  const scene = scenes.find(s => tSec >= s.start && tSec < s.end);
  if (!scene) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  applyStoryboardScene(scene);
  setActiveCallout(scene.callout || null);
  setBalloonsSpec(scene.balloons || null);

  if (scene.trafficAnimation) {
    APPLY_TRAFFIC_OVERRIDE(scene.trafficAnimation);
  } else {
    CLEAR_TRAFFIC_OVERRIDE();
  }
};


  // Fetch podcast audio URL on mount.
  useEffect(() => {
    const storage = getStorage();
    const podcastRefStorage = storageRef(storage, 'Podcast media/street-podcasts/Lakeview-drive/Lakeview-Drive_1760158856.mp3');
    getDownloadURL(podcastRefStorage)
      .then((url) => { setPodcastAudioUrl(url); })
      .catch((error) => { console.error("Error fetching podcast audio:", error); });

  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;
  
    // Clear out any previous graph data immediately
    setGraphData({ links: [], nodes: {}, adjList: {} });
  
    const storage = getStorage();
    const csvRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_links.csv`
    );
  
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
  
        const nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId   = row.end_node_id;
          const geom    = row.geometry
            .replace(/LINESTRING\s*\(/, '')
            .replace(/\)$/, '');
          const coordsArr = geom
            .split(',')
            .map(s => s.trim().split(' ').map(Number));
  
          if (coordsArr.length) {
            const [lng0, lat0] = coordsArr[0];
            const [lngN, latN] = coordsArr[coordsArr.length - 1];
            nodes[startId] = { id: startId, lat: lat0, lng: lng0 };
            nodes[endId]   = { id: endId,   lat: latN, lng: lngN };
          }
        });
  
        const adjList = {};
        parsed.forEach(row => {
          const start  = row.start_node_id;
          const end    = row.end_node_id;
          const length = parseFloat(row.length);
  
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end])   adjList[end]   = [];
  
          adjList[start].push({ node: end, weight: length, link: row });
        });

        console.log(parsed)
  
        setGraphData({ links: parsed, nodes, adjList });

        // Keep global WKT lookup in sync for storyboard
        const linkGeoms = {};
        parsed.forEach(row => {
          linkGeoms[row.link_id] = row.geometry;
        });
        linkGeomsRef.current = linkGeoms;
      })
      .catch(error => console.error('Error fetching CSV:', error));

      fetchAllFireData(selectedSimulation.id)
  }, [selectedSimulation]);

  useEffect(() => {
    const fetchSimulations = async () => {
      try {
        const simsCol   = collection(firestore, 'simulations');
        const simDocs   = await getDocs(simsCol);
        const simList   = simDocs.docs.map(d => ({ id: d.id, ...d.data() }));
        setSimulations(simList);
        if (simList.length) {
          const preferred = simList.find(s => s.name === "FR_N_B19_podcast_2" || s.id === "FR_N_B19_podcast_2");   
          setSelectedSimulation(preferred || simList[simList.length - 1]);
        }
      } catch (err) {
        console.error('Error fetching simulations:', err);
      }
    };
    fetchSimulations();
  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;                       // need the ID
  
    const storage = getStorage();
    const nodesRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_nodes.csv`
    );
  
    getDownloadURL(nodesRef)
      .then(url => fetch(url))
      .then(res => res.text())
      .then(csv => {
        const rows = parseCSV(csv);                        // you already have parseCSV
        const dests = rows
          .filter(r => r.type === 'destination')
          .map(r => ({ nodeId: r.node_id, name: r.name || r.node_id }));
        setDestinationNodes(dests);                        // update state
      })
      .catch(err => console.error('Error loading nodes CSV:', err));
  }, [selectedSimulation]);

  // Language-aware routes audio loader
useEffect(() => {
  const storage = getStorage();
  const FILE_EN = "Podcast media/street-podcasts/Lakeview-drive/Lakeview-Drive_1760158856.mp3";
  // const FILE_ES = "Podcast media/Longview_Drive_Wildfire_Evacuation_ES.m4a";
  const FILE_ES = "Podcast media/Harborview-Drive-ES.mp3";
  const targetPath = (selectedLanguage === 'ES') ? FILE_ES : FILE_EN;

  // Stop & reset any currently playing audio when switching languages
  if (routesAudioRef.current) {
    try {
      routesAudioRef.current.pause();
      routesAudioRef.current.currentTime = 0;
    } catch (_) {}
  }

  (async () => {
    try {
      const url = await getDownloadURL(storageRef(storage, targetPath));
      setRoutesAudioUrl(url);
    } catch (err) {
      console.error("Error fetching language-specific routes audio:", err);
      // Fallback to English if ES isn’t found
      if (selectedLanguage === 'ES') {
        try {
          const urlEn = await getDownloadURL(storageRef(storage, FILE_EN));
          setRoutesAudioUrl(urlEn);
        } catch (err2) {
          console.error("Fallback (EN) also failed:", err2);
          setRoutesAudioUrl(""); // keep player empty on failure
        }
      } else {
        setRoutesAudioUrl("");
      }
    }
  })();
}, [selectedLanguage]);
  

useEffect(() => {
  if (selectedTab !== "routes") {
    STOP_ANIMS();    
    updateRouteOpacity(null);
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setIsPodcastPlaying(false);
    setSafetyCalloutsVisible(true);
    setBalloonsSpec(null);
    setActiveCallout(null);
  }
}, [selectedTab]);

  // Fetch and parse CSV file on mount.
  useEffect(() => {
    const storage = getStorage();
    const csvRef = storageRef(storage, 'simulation_output_1753641819/inputs/berkeley_links.csv');
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
        let nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId = row.end_node_id;
          const geom = row.geometry;
          const coordsString = geom.replace(/LINESTRING\s*\(/, '').replace(/\)$/, '');
          const coordsArr = coordsString.split(',').map(s => s.trim().split(' ').map(Number));
          if (coordsArr.length > 0) {
            if (!nodes[startId]) {
              nodes[startId] = { id: startId, lat: coordsArr[0][1], lng: coordsArr[0][0] };
            }
            if (!nodes[endId]) {
              nodes[endId] = { id: endId, lat: coordsArr[coordsArr.length - 1][1], lng: coordsArr[coordsArr.length - 1][0] };
            }
          }
        });
        let adjList = {};
        parsed.forEach(row => {
          const start = row.start_node_id;
          const end = row.end_node_id;
          const length = parseFloat(row.length);
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end]) adjList[end] = [];
          adjList[start].push({ node: end, weight: length, link: row });
        });
        setGraphData({ links: parsed, nodes, adjList });
      })
      .catch(error => console.error("Error fetching CSV:", error));
  }, []);

  // CSV parser helper.
  const parseCSV = (text) => {
    const lines = text.split('\n').filter(line => line.trim() !== '');
    const header = lines[0].split(',');
    const data = [];
    const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
    for (let i = 1; i < lines.length; i++) {
      let row = lines[i].split(regex);
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index] ? row[index].replace(/^"|"$/g, '') : '';
      });
      data.push(obj);
    }
    return data;
  };

  const clearAndSetFirePolygons = (polys) => {
    const map = mapRef.current;
    // remove any existing
    firePolygonsRef.current.forEach(p => p && p.setMap(null));
    firePolygonsRef.current = [];
  
    // draw the new ones
    polys.forEach((p, idx) => {
      const polygon = new window.google.maps.Polygon({
        paths: p.path,
        fillColor: p.color,
        fillOpacity: 0.8,
        strokeColor: p.color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map,
        zIndex: idx
      });
      firePolygonsRef.current.push(polygon);
    });
  
    setFirePolygons(polys);
  };

  const fetchAllFireData = async (simulationId) => {
       const storage    = getStorage();
       const prefixRef  = storageRef(storage, `${simulationId}/fire_inputs/`);
       const listResult = await listAll(prefixRef);
    
       // 1) load every geojson file
       const rawPolys = [];
       await Promise.all(
         listResult.items
           .filter(item => item.name.endsWith(".geojson"))
           .map(async item => {
             const m = item.name.match(/fire_(\d+)\.geojson$/);
             if (!m) return;
             const time = parseInt(m[1], 10);
             const url  = await getDownloadURL(item);
             const json = await (await fetch(url)).json();
             (json.features || []).forEach(f => {
               rawPolys.push({
                 time,
                 path: f.geometry.coordinates[0].map(([lng,lat])=>({lat,lng}))
               });
             });
           })
       );
    
       // 2) dedupe identical shapes
       const seen = new Set();
       const uniq = [];
       rawPolys.forEach(p => {
         const key = JSON.stringify(p.path);
         if (!seen.has(key)) {
           seen.add(key);
           uniq.push(p);
         }
       });
    
       if (uniq.length === 0) {
         clearAndSetFirePolygons([]);
         return;
       }
    
       // 3) sort by time descending (latest first)
       uniq.sort((a,b) => b.time - a.time);
    
       // 4) assign a colour gradient yellow→red
       const N = uniq.length;
       uniq.forEach((p,i) => {
         const t   = (N-1-i) / (N - 1 || 1);
         const g   = Math.round(255 - (255 - 69) * t);
         p.color   = `rgb(255,${g},0)`;
       });
    
       // 5) draw stacked
       clearAndSetFirePolygons(uniq);
     };
  
  

  const handleGetTravelExperience = async () => {
    if (!selectedLocation) {
      window.alert('Click on the map first to choose your starting point.');
      return;
    }

    console.log("Here graphdata2", graphData)
  
    try {
      const exp = await getTravelExperiencesV2({
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        graphData,
        destinationNodes,
        selectedTime: Number(time),
        simulation: selectedSimulation,
        apiAbortSignal: apiCallControllerRef.current?.signal
      });
      console.log('Travel experience log:', exp);
      setTravelExperiences(exp);

      const narrative = buildTravelNarrativeV3(exp, selectedLocation, Number(time));
      setTravelExpNarrativeStream(narrative);

      
      /* 
      
      const uploadPoint = Date.now();
  
      await getTravelExperienceEnglishSummary(
        exp,
        selectedLocation,
        Number(time),
        uploadPoint
      );


      const db = getDatabase();
      const evac_experience_content_ref = ref(
        db,
        `/generated_narrative/${uploadPoint}`
      );
      onValue(evac_experience_content_ref, (snapshot) => {
        const val = snapshot.val();
        console.log(val)
        if (val && typeof val === "string") {
          setTravelExpNarrativeStream(val);       // reuse existing audio/text display
        }
      });
      */

    } catch (err) {
      console.error('Could not get travel experience', err);
    }
  };
 

  // Function to play podcast audio.
  const playSection = (startTime) => {
    if (podcastAudioRef.current) {
      podcastAudioRef.current.currentTime = startTime;
      //podcastAudioRef.current.play();
    }
  };

  const playRouteSection = (startTime) => {
    if (routesAudioRef.current) {
      routesAudioRef.current.currentTime = startTime;
      // routesAudioRef.current.play();
    }
  };

  const handleNodeIdSubmit = () => {
    const raw = String(nodeIdText).trim();
    if (!raw) return;
  
    const id = raw; // keep as string; your nodes keys are strings
    if (!graphData?.nodes?.[id]) {
      window.alert("That node id is not in the current graph.");
      return;
    }
  
    const { lat, lng } = graphData.nodes[id];
  
    setSelectedLocation({ lat, lng });
    if (mapRef.current) {
      modifyMapCamera(mapRef.current, { lat, lng }, 14.5, 800);
    }
  
    if (selectedSimulation) {
      wantRoutesAutoplayRef.current = false;
      drawRoutes(lat, lng, time, selectedSimulation, destinationNodes, id);
    }
  };

  const createTextOverlay = (position, text) => {
    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function() {
      this.div = document.createElement("div");
      // Style the overlay div as desired:
      this.div.style.position = "absolute";
      this.div.style.background = "rgba(255, 255, 255, 0.9)";
      this.div.style.color = "#000";
      this.div.style.padding = "2px 4px";
      this.div.style.borderRadius = "4px";
      this.div.style.fontSize = "16px";
      this.div.innerHTML = text;
      const panes = this.getPanes();
      panes.floatPane.appendChild(this.div);
    };
    overlay.draw = function() {
      const projection = this.getProjection();
      // Convert the geographical position to pixel coordinates.
      const point = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(position.lat, position.lng));
      if (point && this.div) {
        // Adjust the position so the overlay appears centered above the marker.
        this.div.style.left = (point.x - this.div.offsetWidth / 2) + "px";
        this.div.style.top = (point.y - this.div.offsetHeight - 20) + "px"; // 5px above
      }
    };
    overlay.onRemove = function() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    };
    overlay.setMap(mapRef.current);
    return overlay;
  };

  const apiCallControllerRef = useRef(null);

  const getDominantStreetName = (nodeId, links) => {
    const counts = new Map(); // name -> {count, firstIdx}
    let idx = 0;
    for (const row of links || []) {
      const sid = String(row.start_node_id);
      const eid = String(row.end_node_id);
      if (String(nodeId) === sid || String(nodeId) === eid) {
        const nm = (row.name || "").trim();
        if (!nm) { idx++; continue; }
        if (!counts.has(nm)) counts.set(nm, { count: 0, firstIdx: idx });
        const rec = counts.get(nm);
        rec.count += 1;
      }
      idx++;
    }
    let best = "";
    let bestCount = -1;
    let bestFirst = Infinity;
    for (const [nm, rec] of counts.entries()) {
      if (rec.count > bestCount || (rec.count === bestCount && rec.firstIdx < bestFirst)) {
        best = nm; bestCount = rec.count; bestFirst = rec.firstIdx;
      }
    }
    return best || "";
  };

  const drawRoutes = async (lat, lng, selectedTime, selectedSimulation, dests, forceNodeId = null) => {
    if (!dests || dests.length === 0) return;
  
    // Abort any ongoing calls
    if (apiCallControllerRef.current) apiCallControllerRef.current.abort();
    apiCallControllerRef.current = new AbortController();
  
    // Location marker
    if (circleRef.current) circleRef.current.setMap(null);
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: { url: LocationIcon, scaledSize: new window.google.maps.Size(50, 50), anchor: new window.google.maps.Point(25, 25) },
    });
    circleRef.current = locationMarker;
  
    // Clear old overlays
    STOP_ANIMS(); 
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    routesDataRef.current = [];
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }
  
    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) return;
  
    // Build link geometry lookup
    const linkGeoms = {};
    (graphData.links || []).forEach(row => { linkGeoms[row.link_id] = row.geometry; });
    linkGeomsRef.current = linkGeoms;
  
    // Find nearest node to click
    let nearestNodeId = null, minDist = Infinity;
    if (forceNodeId != null && graphData.nodes[String(forceNodeId)]) {
      nearestNodeId = String(forceNodeId);
      const n = graphData.nodes[nearestNodeId];
      lat = n.lat;
      lng = n.lng;
    } else {
      for (const node of Object.values(graphData.nodes)) {
        const d = haversineDistance(lat, lng, node.lat, node.lng);
        if (d < minDist) { minDist = d; nearestNodeId = node.id; }
      }
    }
    if (nearestNodeId == null) return;
    nearestNodeIdRef.current = nearestNodeId;

    const dominantStreet = getDominantStreetName(nearestNodeId, graphData.links);
    console.log("Dominant street", dominantStreet)
    setSelectedLocation(prev => ({ ...(prev || {}), lat, lng, street: dominantStreet || (prev?.street || "") }));
  
    // ---- NEW LOGIC (modular): pick two closest destinations with route diversity ----
    const selectedRoutes = selectTwoDiverseRoutes({
      graphData,
      nearestNodeId,
      dests,
      selectedTime
    });
    if (!selectedRoutes || selectedRoutes.length === 0) return;
  
    // ---- Everything below remains the same, but iterate over selectedRoutes instead of dests ----
    const routesData = [];
  
    for (const sel of selectedRoutes) {
      const route = sel.node_path;
      const routeCoords = route.map(nodeId => {
        const node = graphData.nodes[nodeId];
        return { lat: node.lat, lng: node.lng };
      });
  
      const pathLinks = sel.link_ids || [];
  
      // Draw true geometry per link
      const routePolylines = pathLinks.map(linkId => {
        const wkt = linkGeoms[linkId];
        if (!wkt) return null;
        const coords = wkt
          .replace(/^LINESTRING\s*\(/i, '')
          .replace(/\)$/, '')
          .split(',')
          .map(pt => {
            const [lng2, lat2] = pt.trim().split(' ').map(Number);
            return { lat: lat2, lng: lng2 };
          });
  
        return new window.google.maps.Polyline({
          path: coords,
          geodesic: true,
          strokeColor: "#186EE3",
          strokeOpacity: 0.35,
          strokeWeight: 5,
          zIndex: -1000,
          clickable: true
        });
      }).filter(Boolean);
  
      // Put on map & wire clicks
      routePolylines.forEach((poly, idx) => {
        poly.setMap(mapRef.current);
        const linkId = pathLinks[idx];
        poly.addListener("click", () => console.log(`Link ID: ${linkId}`));
        polylineRefs.current.push(poly);
      });
  
      // Destination marker
      const destinationPos = routeCoords[routeCoords.length - 1];
      const destMarker = new window.google.maps.Marker({
        position: destinationPos,
        map: mapRef.current,
        icon: { url: SafetyIcon, scaledSize: new window.google.maps.Size(40, 40), anchor: new window.google.maps.Point(20, 20) },
        opacity: 1
      });
      destMarker.addListener('click', () => console.log(`Destination node ID: ${sel.nodeId}`));


      // Hospital marker
      if (!hospitalMarkerRef.current) {

        let marker = new window.google.maps.Marker({
          position: { lat: 37.715885, lng: -122.130340 },
          map: mapRef.current,
          icon: {
            url: HospitalIcon,
            scaledSize: new window.google.maps.Size(48, 48),
            anchor: new window.google.maps.Point(24, 24),
          },
          title: "Hospital",
        });

        hospitalMarkerRef.current = marker
  
      } else {
        hospitalMarkerRef.current.setMap(mapRef.current);
      }
  
      // Store for API update
      routesData.push({
        destNodeId: sel.nodeId,
        pathLinks,
        routePolylines,
        destinationPos,
        destMarker
      });
    }
  
    routesDataRef.current = routesData;

    // Auto-play the routes podcast once routes are drawn
    console.log("Autoplay 1", routesData, routesAudioRef, routesAudioUrl)
    if (routesData.length > 0 && routesAudioRef.current && routesAudioUrl) {
      try {
        console.log("Autoplay 2")
        if (routesAudioRef.current.paused) {
          routesAudioRef.current.currentTime = 0;
          // routesAudioRef.current.play();
        }
      } catch (err) {
        console.error("Auto-play failed:", err);
      }
    }
  
    // Fire API calls concurrently (unchanged)
    await Promise.all(routesData.map(async (routeData) => {
      const apiResponse = await getPathTimes(
        routeData.pathLinks,
        selectedTime,
        selectedSimulation.id,
        selectedSimulation.isInteractiveMap,
        apiCallControllerRef.current.signal
      );
  
      if (apiResponse && apiResponse.link_times) {
        apiResponse.link_times.forEach((linkData, idx) => {
          const poly = routeData.routePolylines[idx];
          if (!poly) return;

          const queuedCount = Number(linkData?.queued_vehicles || 0);
      
          // base color is blue; switch to orange if queued
          let color = "#186EE3";
          if (linkData?.queued_vehicles >= 1) {
            color = "#186EE3";
            poly.setOptions({ strokeColor: color });
          }

          console.log("linkData", linkData)
      
          // If queue exists, we want the free section to show orange moving dots at fft 5.
          // Otherwise use the API travel_time (your existing behavior).
          let fftSec = 5;
          if (queuedCount <= 0) {
            fftSec = Number(linkData?.travel_time) / 6 || 5;
          }

          START_LINK_ANIM(poly, "#186EE3", fftSec);
          // Fill the tail with static red dots; spacingPct can be tuned (e.g., 3–6)
          SET_LINK_QUEUE(poly, queuedCount, 4);
        });
      }
  
      if (apiResponse && typeof apiResponse.total_time !== "undefined") {
        const totalTimeSeconds = Math.round(apiResponse.total_time) + Math.round(selectedTime);
        const totalTimeStr = formatTime(totalTimeSeconds, { style: "digital" });
        const textOverlay = createTextOverlay(routeData.destinationPos, totalTimeStr);

        // If podcast is playing right now, keep this new overlay hidden
        const isPlayingNow = !!routesAudioRef.current && !routesAudioRef.current.paused;
        if (isPlayingNow) {
          textOverlay.setMap(null);
        }
        safetyCalloutsRef.current.push(textOverlay);
      }
    }));
  };

  const drawRoutesOld = async (lat, lng, selectedTime, selectedSimulation, dests) => {

    if (!dests || dests.length === 0) return; 

    // Cancel any ongoing API calls.
    if (apiCallControllerRef.current) {
      apiCallControllerRef.current.abort();
    }
    // Create a new controller for this set of API calls.
    apiCallControllerRef.current = new AbortController();

    // Draw a location marker using the LocationIcon.
    if (circleRef.current) {
      circleRef.current.setMap(null);
    }
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: {
        url: LocationIcon,
        scaledSize: new window.google.maps.Size(50, 50),
        anchor: new window.google.maps.Point(25, 25),
      },
    });
    circleRef.current = locationMarker;

    // Clear existing polylines and car markers.
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    routesDataRef.current = [];

    // Clear existing safety callouts.
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }

    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) return;

    console.log("Graph data:", graphData)

     // 4️⃣ build a lookup table: link_id → its raw WKT geometry
     const linkGeoms = {};
     graphData.links.forEach(row => {
       linkGeoms[row.link_id] = row.geometry;
     });
     linkGeomsRef.current = linkGeoms;

    // Find the nearest node to the click.
    let nearestNodeId = null;
    let minDist = Infinity;
    for (const node of Object.values(graphData.nodes)) {
      const d = haversineDistance(lat, lng, node.lat, node.lng);
      if (d < minDist) {
        minDist = d;
        nearestNodeId = node.id;
      }
    }
    console.log("Nearest node:", nearestNodeId);

    // Run Dijkstra from that node.
    const { distances, previous } = dijkstra(graphData.adjList, nearestNodeId);

    // Create an array to collect route data for all destinations.
    const routesData = [];

    // Process each destination.
    for (const dest of dests) {
      if (distances[dest.nodeId] < Infinity) {
        // Reconstruct the route (node IDs).
        const route = reconstructPath(previous, nearestNodeId, dest.nodeId);
        console.log(`Route to ${dest.nodeId}:`, route);

        // Convert node IDs to coordinates.
        const routeCoords = route.map(nodeId => {
          const node = graphData.nodes[nodeId];
          return { lat: node.lat, lng: node.lng };
        });

        // Build link IDs for the route.
        const pathLinks = [];
        for (let i = 0; i < route.length - 1; i++) {
          const currNodeId = route[i];
          const nextNodeId = route[i + 1];
          let linkId = null;
          if (graphData.adjList[currNodeId]) {
            const edge = graphData.adjList[currNodeId].find(e => e.node === nextNodeId);
            if (edge && edge.link) {
              linkId = edge.link.link_id; // Assumes CSV data contains "link_id"
            }
          }
          if (linkId !== null) {
            pathLinks.push(linkId);
          }
        }
        console.log("Path links for destination", dest.nodeId, ":", pathLinks);

        // Draw the route entirely in default blue.
        // c) draw each link’s true geometry, with a forward arrow at the end
        const routePolylines = pathLinks.map(linkId => {
          const wkt = linkGeoms[linkId];
          if (!wkt) return null;
          // parse "LINESTRING(lng lat, lng lat, ...)"
          const coords = wkt
            .replace(/^LINESTRING\s*\(/i, '')
            .replace(/\)$/, '')
            .split(',')
            .map(pt => {
              const [lng, lat] = pt.trim().split(' ').map(Number);
              return { lat, lng };
            });

          return new window.google.maps.Polyline({
            path: coords,
            geodesic: true,
            strokeColor: "#186EE3",
            strokeOpacity: 1,
            strokeWeight: 5,
            zIndex: -1000,
            clickable: true
          });
        })
        .filter(p => p !== null);

        // d) put them on the map & wire up clicks
        routePolylines.forEach((poly, idx) => {
          poly.setMap(mapRef.current);
          const linkId = pathLinks[idx];
          poly.addListener("click", () => console.log(`Link ID: ${linkId}`));
          polylineRefs.current.push(poly);
        });


        // Place a safety marker at the destination.
        const destinationPos = routeCoords[routeCoords.length - 1];
        const destMarker = new window.google.maps.Marker({
          position: destinationPos,
          map: mapRef.current,
          icon: {
            url: SafetyIcon,
            scaledSize: new window.google.maps.Size(40, 40),
            anchor: new window.google.maps.Point(20, 20),
          },
          opacity: 1
        });

        // log the nodeId when the flag is clicked
          destMarker.addListener('click', () => {
            console.log(`Destination node ID: ${dest.nodeId}`);
          });

        // Store this route for later API update.
        routesData.push({
          destNodeId: dest.nodeId,
          pathLinks,  
          routePolylines,
          destinationPos,
          destMarker
        });
      }
    } // end for each destination

    routesDataRef.current = routesData;

    // Fire off all API calls concurrently.
    await Promise.all(routesData.map(async (routeData) => {
      // Pass the abort signal from our controller.
      const apiResponse = await getPathTimes(routeData.pathLinks, selectedTime, selectedSimulation.id, selectedSimulation.isInteractiveMap, apiCallControllerRef.current.signal);
      // Update polyline colors based on traffic congestion.
      if (apiResponse && apiResponse.link_times) {
        apiResponse.link_times.forEach((linkData, idx) => {
          if (linkData.queued_vehicles >= 1 && routeData.routePolylines[idx]) {
            routeData.routePolylines[idx].setOptions({ 
              strokeColor: "#FFA000",
             });
          }
        });
      }
      // Create a text overlay for total travel time.
      if (apiResponse && typeof apiResponse.total_time !== "undefined") {
        const totalTimeSeconds = Math.round(apiResponse.total_time) + Math.round(selectedTime);
        console.log("Calculating total time", "selectedTime:", selectedTime, "API response time:", apiResponse.total_time, "Total time:", totalTimeSeconds)
        const totalTimeStr = formatTime(totalTimeSeconds, { style: "digital" });
        const textOverlay = createTextOverlay(routeData.destinationPos, totalTimeStr);
        safetyCalloutsRef.current.push(textOverlay);
      }
    }));
  }

  const handleMapClick = async (e) => {

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setSelectedLocation({lat: lat, lng: lng})

    console.log("Map clicked at:", { lat, lng, time, selectedSimulation });

    wantRoutesAutoplayRef.current = false;
    drawRoutes(lat, lng, time, selectedSimulation, destinationNodes)
    
  };



  const handleTimeChange = (e) => { 
    const newT = Number(e.target.value);
    setTime(newT);
    if (selectedLocation && selectedSimulation) {
      drawRoutes(selectedLocation.lat, selectedLocation.lng, newT, selectedSimulation, destinationNodes);
    }

  };

  const togglePolylines = () => { setShowPolyLines(!showPolyLines); };

  const handleSimulationChange = (e) => {
    const simID = e.target.value;
    console.log(simID)
    const sim = simulations.find(s => s.id === simID);
    if (sim) setSelectedSimulation(sim);

    if (selectedLocation && selectedSimulation) {
       drawRoutes(selectedLocation.lat, selectedLocation.lng, time, sim, destinationNodes);
    }
  };

  const loadFireOverlay = () => {
    // Add the fire marker here:
    // Define the fixed center and the offset in meters
    const fireCenter = { lat: 37.891993946041026, lng: -122.24859240728762 };
    const meters = 400; // adjust this value: approximately 150 meters covers 3 blocks
    const meterToDegLat = 1 / 111000; // roughly 1° latitude = 111 km
    // For longitude, adjust by the cosine of the latitude.
    const meterToDegLng = 1 / (111000 * Math.cos(fireCenter.lat * Math.PI / 180));
    const latOffset = meters * meterToDegLat;
    const lngOffset = meters * meterToDegLng;

    // Create bounds for the GroundOverlay.
    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(fireCenter.lat - latOffset, fireCenter.lng - lngOffset),
      new window.google.maps.LatLng(fireCenter.lat + latOffset, fireCenter.lng + lngOffset)
    );

    // Create and display the GroundOverlay using your FireImage.
    new window.google.maps.GroundOverlay(FireImage, bounds, { opacity: 0.75 }).setMap(mapRef.current);
  }

  

  const audioSegments = React.useMemo(() => {
    const sorted = Object.entries(activeRoutesAudioTimings)
      .map(([title, start]) => ({ title, start }))
      .sort((a, b) => a.start - b.start);
    sorted.forEach((seg, i) => seg.end = i < sorted.length - 1 ? sorted[i + 1].start : Infinity);
    return sorted;
  }, [activeRoutesAudioTimings]);
  
  const nodeIdForTime = (t) => {
    const seg = audioSegments.find(s => t >= s.start && t < s.end);
    if (!seg) return null;
    const item = activeChecklistItems.find(i => i.title === seg.title);
    return item?.nodeId ?? null;
  };

  const updateRouteOpacity = (activeNodeId) => {
    routesDataRef.current.forEach(r => {
      const isActive = activeNodeId && String(r.destNodeId) === String(activeNodeId);
  
      // Polylines: keep all on map, dim non-active
      r.routePolylines.forEach(p => {
        p.setOptions({ strokeOpacity: isActive ? 1 : (activeNodeId ? 0.05 : 1) });
        if (p.getMap() === null) p.setMap(mapRef.current);
        SET_LINK_ANIM_VISIBLE(p, !!(isActive || !activeNodeId));
      });
  
      // Destination markers: ONLY show the active one when a node is active
      if (activeNodeId) {
        if (isActive) {
          if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
          r.destMarker.setOpacity(1);
        } else {
          r.destMarker.setOpacity(0.05);
        }
      } else {
        // No active node: show all again
        if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
        r.destMarker.setOpacity(1);
      }
    });
  };

  const handleLocationSearch = async () => {
    const query = searchText.trim();
    if (!query) return;
  
    try {
      setIsSearchingLoc(true);
      const { lat, lng } = await geocodeAddress(query, "", "");      // already imported
      const latNum = +lat, lngNum = +lng;
  
      setSelectedLocation({ lat: latNum, lng: lngNum });
  
      if (mapRef.current) {
        modifyMapCamera(
          mapRef.current,
          { lat: latNum, lng: lngNum }, // target centre
          14.5,                           // target zoom
          1000                          // duration (ms)
        );
      }
      if (selectedSimulation){
        wantRoutesAutoplayRef.current = false;
        drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);
      }
    } catch (err) {
      console.error("Geocode failed:", err);
    } finally {
      setIsSearchingLoc(false);
    }
  };

  const modifyMapCamera = (map, endCenter, endZoom, duration = 1000) => {
    const startCenter = map.getCenter().toJSON();
    const startZoom   = map.getZoom();
    const frames      = Math.round((duration / 1000) * 60); // ~60 fps
    let frame = 0;
  
    const latDiff  = endCenter.lat - startCenter.lat;
    const lngDiff  = endCenter.lng - startCenter.lng;
    const zoomDiff = endZoom       - startZoom;
  
    const step = () => {
      frame += 1;
      const t    = frame / frames;
      const ease = t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;   // ease-in/out
  
      map.setCenter({
        lat: startCenter.lat + latDiff * ease,
        lng: startCenter.lng + lngDiff * ease
      });
      map.setZoom(startZoom + zoomDiff * ease);
  
      if (frame < frames) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };


  return (
    <div style={{ display: "flex", flexDirection: "row", padding: "20px", color: "#000" }}>
      {/* Left Pane */}
      <div style={{ flex: "0 0 40%", marginRight: "20px" }}>
        <h1>Wildfire Pre-planning</h1>


        <div style={{ width: "100%", display: "flex", alignItems: "center", gap: 16, marginBottom: '20px' }}>
          <strong>Language:</strong>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectedLanguage === 'EN'}
              onChange={() => setSelectedLanguage('EN')}
            />
            English
          </label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectedLanguage === 'ES'}
              onChange={() => setSelectedLanguage('ES')}
            />
            Spanish
          </label>
        </div>

        {!isMobile && (
          <SearchBar
            value={searchText}
            onChange={setSearchText}
            onSubmit={handleLocationSearch}
            isLoading={isSearchingLoc}
            containerStyle={{ marginBottom: 12, marginTop: 30 }}
          />
        )}

        {!isMobile && (
          <div style={{ display: "flex", gap: 8, marginTop: 8, marginBottom: 12 }}>
            <input
              type="number"
              inputMode="numeric"
              placeholder="NodeId (optional)"
              value={nodeIdText}
              onChange={(e) => setNodeIdText(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") handleNodeIdSubmit(); }}
              style={{
                flex: 1,
                padding: "8px 10px",
                border: "1px solid #ccc",
                borderRadius: 6
              }}
            />
            <button
              onClick={handleNodeIdSubmit}
              style={{
                padding: "8px 12px",
                border: "none",
                borderRadius: 6,
                background: "#0b5fff",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
                whiteSpace: "nowrap"
              }}
              title="Route from this node"
            >
              Go
            </button>
          </div>
        )}

        
        {selectedLocation && (
          <div style={{ marginTop: "20px" }}>
          <div style={{ padding: "20px", border: "1px solid #ccc" }}>


            {selectedTab === "routes" && (
              <div>
                {/* ❶ Audio player */}
                {routesAudioUrl && (
                  <div style={{ marginBottom: "20px" }}>
                    <audio
                      controls
                      src={routesAudioUrl}
                      ref={routesAudioRef}
                      style={{ width: "100%" }}
                      onCanPlay={() => {
                        if (wantRoutesAutoplayRef.current && routesAudioRef.current) {
                          try {
                            routesAudioRef.current.currentTime = 0;
                            // routesAudioRef.current.play();
                          } finally {
                            wantRoutesAutoplayRef.current = false;
                          }
                        }
                      }}
                      onPlay={() => {
                        setIsPodcastPlaying(true);
                        setSafetyCalloutsVisible(false);
                        resourcesAudioRef.current?.pause();
                      }}
                      onPause={() => {
                        activeRouteNodeRef.current = null;
                        updateRouteOpacity(null);
                        hideAllStoryboardOverlays();
                        lastStoryboardCameraRef.current = null;
                        setIsPodcastPlaying(false);
                        setSafetyCalloutsVisible(true);
                        setActiveCallout(null);
                        setBalloonsSpec(null);
                      }}
                      onEnded={() => {
                        activeRouteNodeRef.current = null;
                        updateRouteOpacity(null);
                        hideAllStoryboardOverlays();
                        lastStoryboardCameraRef.current = null;
                        setIsPodcastPlaying(false);
                        setSafetyCalloutsVisible(true);
                        setActiveCallout(null);
                        setBalloonsSpec(null);
                      }}
                      onTimeUpdate={(e) => {
                        const t = e.currentTarget.currentTime;
                        const node = nodeIdForTime(t);
                        if (node !== activeRouteNodeRef.current) {
                          activeRouteNodeRef.current = node;
                          updateRouteOpacity(node);
                        }
                        applyStoryboardForTime(t);
                      }}
                    />
                  </div>
                )}
            
                {/* ❷ Checklist (same hover‑play style you used before) */}
                <style>{`
                  .route-check-item {
                    width: 350px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    padding: 5px;
                    position: relative;
                  }
                  .route-check-item .play-button { display: none; }
                  .route-check-item:hover .play-button { display: block; }
                `}</style>
            
                {activeChecklistItems.map((item) => (
                  <div key={item.key} className="route-check-item" style={{ marginBottom: 10 }}>
                    <label style={{ display: "flex", alignItems: "center", flex: 1 }}>
                      <input type="checkbox" checked={false} onChange={() => {}} style={{ marginRight: 8 }} />
                      <span>{item.title}</span>
                    </label>
                    <button
                      className="play-button"
                      onClick={() => {
                        const t = activeRoutesAudioTimings[item.title];
                        if (typeof t === "number") playRouteSection(t);
                      }}
                      style={{ background: "#007BFF", color: "#fff", border: "none", padding: "5px 10px", borderRadius: 4, cursor: "pointer" }}
                    >
                      Play
                    </button>
                  </div>
                ))}
                {travelExperiences && (<button
                  onClick={handleGetTravelExperience}
                  disabled={!selectedLocation}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: selectedLocation ? '#007BFF' : '#999',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: selectedLocation ? 'pointer' : 'not-allowed',
                    marginBottom: '16px'
                  }}
                >
                  Get travel narrative
                </button>
                )}

                {/* Save route tables button */}
                {Array.isArray(travelExperiences) && travelExperiences.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <button
                      onClick={handleSaveRouteTables}
                      disabled={isSavingRoutes || !nearestNodeIdRef.current}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: (!nearestNodeIdRef.current || isSavingRoutes) ? '#999' : '#10B981',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: (!nearestNodeIdRef.current || isSavingRoutes) ? 'not-allowed' : 'pointer',
                        marginRight: 8
                      }}
                    >
                      {isSavingRoutes ? "Saving..." : "Save route tables"}
                    </button>
                    {!!saveMsg && <span style={{ color: '#111', marginLeft: 8 }}>{saveMsg}</span>}
                  </div>
                )}

                {travelExperiences && (
                  <div>NodeId: {nearestNodeIdRef.current}</div>
                )}

                {travelExperiences && !travelExpNarrativeStream && (
                  <pre style={{ maxHeight: 300, overflow: 'auto', background: '#f9f9f9', padding: 8 }}>
                    {JSON.stringify(travelExperiences, null, 2)}
                  </pre>
                )}

                {travelExpNarrativeStream && (
                  <pre style={{ maxHeight: 700, width: 700, overflow: 'auto', background: '#f9f9f9', padding: 8 }}>
                    {travelExpNarrativeStream}
                  </pre>
                )}
              </div>
            )}

        {!isPodcastPlaying && (
          <div>
          <div style={{ marginTop: 18, paddingTop: 14, borderTop: "1px solid #e5e7eb" }}>
            <h3 style={{ margin: 0, marginBottom: 10 }}>{resourcesI18n.title}</h3>

            {/* Hidden audio element for snippets */}
            <audio
              ref={resourcesAudioRef}
              src={resourcesAudioUrl}
              preload="metadata"
              style={{ display: "none" }}
            />

            {resourceSegments.map(seg => {
                  const title = seg.key === 'zones'  ? resourcesI18n.know   : resourcesI18n.alerts;
                  const sub   = seg.key === 'zones'  ? "Learn about emergency evacuation zones in your area"
                                                    : "Get emergency notifications directly to your phone";
                  const href  = seg.key === 'zones'  ? RES_URL_KNOW : RES_URL_ALERTS;
                  const durSec   = Math.max(0, seg.end - seg.start);
                  const played   = Math.max(0, Math.min(resourceProgress[seg.key] || 0, durSec));
                  const pct      = durSec ? (played / durSec) : 0;
                  const isActive = activeResourceKey === seg.key;

                  return (
                    <div
                      key={seg.key}
                      style={{
                        background: "#fff",
                        borderRadius: 8,
                        padding: "12px 14px",
                        marginBottom: 12,
                        boxShadow: "0 1px 2px rgba(0,0,0,.06)"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                        <div>
                          <a
                            href={href}
                            onClick={() => playResourceSegment(seg)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: 600, color: "#0b5fff", textDecoration: "underline" }}
                          >
                            {title}
                          </a>
                        </div>

                        <button
                          onClick={() => playResourceSegment(seg)}
                          title={isActive ? "Stop" : "Play"}
                          aria-label={isActive ? "Stop" : "Play"}
                          style={{
                            width: 22, height: 22, borderRadius: "50%",
                            background: 'none',
                            border: "none", cursor: "pointer", flexShrink: 0,
                            padding:'2px',
                            cursor: 'pointer'
                          }}
                        >
                          {isActive ? "■" : "▶︎"}
                        </button>
                      </div>

                      {/* Timer + progress (hidden until playback > 0) */}
                      {played > 0 && isActive? (
                        <div style={{ marginTop: 10 }}>
                          <div style={{ height: 6, background: "#e5e7eb", borderRadius: 3 }}>
                            <div style={{
                              width: `${pct * 100}%`,
                              height: "100%", borderRadius: 3, background: "#0f172a"
                            }} />
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#64748b", marginTop: 6 }}>
                            <span>{formatTime(Math.floor(played), { style: "digital" })}</span>
                            <span>{formatTime(Math.floor(durSec), { style: "digital" })}</span>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
          </div>

              {/* FAQ Section */}
          <div className="faq" style={{ marginTop: 18, paddingTop: 14, borderTop: "1px solid #e5e7eb" }}>
            <h3 style={{ margin: 0, marginBottom: 10 }}>FAQ</h3>
            {(faqList || []).map((qa) => (
              <details
                key={qa.key || qa.q}
                style={{
                  background: "#fff",
                  borderRadius: 8,
                  padding: "12px 14px",
                  marginBottom: 12,
                  boxShadow: "0 1px 2px rgba(0,0,0,.06)"
                }}
              >
                <summary style={{ fontWeight: 600, cursor: "pointer", outline: "none" }}>
                  {qa.q}
                </summary>
                <div style={{ marginTop: 8, color: "#111", lineHeight: 1.5 }}>
                  {qa.a}
                </div>
              </details>
            ))}
          </div>
        </div>
        )}


          </div>
        </div>
        )}
      </div>
      
      {/* Right Pane */}
      <div style={{ flex: "0 0 58%" }}>
        <div style={{ marginBottom: "20px", position: "relative" }}>
          {/* Simulation Dropdown & Time Slider */}
          <select
            value={selectedSimulation?.id || ''}
            onChange={handleSimulationChange}
            style={{ padding:'5px', borderRadius:'4px', fontSize:'14px',
                    border:'1px solid #444', marginRight:'20px' }}>
            {simulations.map(sim => (
              <option key={sim.id} value={sim.id}>{sim.name}</option>
            ))}
          </select>
          <div style={{ paddingTop: "20px", marginBottom: "10px" }}>
            <input
              type="range"
              min="0"
              max={selectedSimulation?.total_time || 0}
              step="30"
              value={time}
              onChange={handleTimeChange}
              style={{
                width: "100%",
                marginBottom: "10px",
                backgroundColor: "#3A3A3A"
              }}
            />
            <div style={{ textAlign: "center" }}>Delayed by {formatTime(time)}</div>
          </div>


          <div style={{ position: "relative", marginTop: 10 /* NEW wrapper */ }}>
            <div
              style={{
                position: "absolute",
                top: 10, left: 0, right: 0,
                width: "90%", maxWidth: 500, margin: "0 auto",
                zIndex: 5
              }}
            >
              {!isPodcastPlaying && isMobile && (
                <SearchBar
                  value={searchText}
                  onChange={setSearchText}
                  onSubmit={handleLocationSearch}
                  isLoading={isSearchingLoc}
                />
              )}

              {isPodcastPlaying && activeCallout && (
                  <div
                  style={{
                    background: activeCallout.bg || "#fff",
                    color: activeCallout.textColor || "#111",
                    borderRadius: 14,
                    padding: "12px 16px",
                    boxShadow: "0 8px 24px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.12)",
                    fontSize: 18,         
                    lineHeight: 1.4,
                    fontFamily:
                      '"Segoe Print","Comic Sans MS","Bradley Hand","Apple Chancery","Caveat","Patrick Hand",cursive',
                    whiteSpace: "pre-line"
                  }}
                >
                  {activeCallout.text}
                </div>
                )}
            </div>

            <BalloonsOverlay
              show={!!balloonsSpec}
              count={balloonsSpec?.count ?? 15}
              emoji={balloonsSpec?.emoji ?? "🎈"}
              minDuration={balloonsSpec?.minDuration ?? 3.0}
              maxDuration={balloonsSpec?.maxDuration ?? 4.2}
              topBeyondVh={balloonsSpec?.topBeyondVh ?? 180}
            />

            <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
            
            
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={14.5}
                onLoad={(map) => {
                  mapRef.current = map;
                  setMapReady(true);
                }}
                onClick={handleMapClick}
                options={{
                  styles: darkMapStyle,
                  disableDefaultUI: true,
                  mapTypeControl: false,
                  zoomControl: false,
                  streetViewControl: false,
                  fullscreenControl: false,
                  scaleControl: false,
                  rotateControl: false,
                  keyboardShortcuts: false
                }}
              >
                {/* Render additional overlays, e.g., car markers via state */}
                {carOverlays}
              </GoogleMap>
            </LoadScript>
            </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveMapOld;
